import "./multiSelectScrollStyles.css"

/**
 * Keep multi-select control height fixed; selected chips scroll horizontally.
 * Does not override chip colors — portal theme.scss styles those via classNamePrefix.
 * Indicators (clear x / chevron) stay pinned via CSS; see multiSelectScrollStyles.css.
 */
export const MULTI_SELECT_CLASS_NAME_PREFIX = "select"

export const multiSelectScrollStyles = {
  control: provided => ({
    ...provided,
    width: "100%",
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    alignItems: "center",
    minHeight: "44px",
    height: "44px",
    maxHeight: "44px",
    overflow: "hidden",
  }),
  valueContainer: provided => ({
    ...provided,
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    alignItems: "center",
    flex: "1 1 auto",
    minWidth: 0,
    height: "100%",
    maxHeight: "100%",
    overflowX: "scroll",
    overflowY: "hidden",
    paddingTop: 4,
    paddingBottom: 10,
    scrollbarWidth: "thin",
  }),
  multiValue: provided => ({
    ...provided,
    flex: "0 0 auto",
    maxWidth: "none",
    marginTop: 0,
    marginBottom: 0,
  }),
  input: provided => ({
    ...provided,
    margin: 0,
    padding: 0,
    minWidth: "40px",
  }),
  indicatorsContainer: provided => ({
    ...provided,
    display: "flex",
    flex: "0 0 auto",
    flexShrink: 0,
    flexWrap: "nowrap",
    alignItems: "center",
    alignSelf: "stretch",
    height: "100%",
  }),
  clearIndicator: provided => ({
    ...provided,
    flexShrink: 0,
  }),
  dropdownIndicator: provided => ({
    ...provided,
    flexShrink: 0,
  }),
  indicatorSeparator: provided => ({
    ...provided,
    flexShrink: 0,
  }),
  placeholder: provided => ({
    ...provided,
    whiteSpace: "nowrap",
  }),
}

/** Shared props for Add/Edit Item multi-selects (scroll + theme chip colors). */
export const multiSelectFieldProps = {
  className: "item-multi-select-scroll",
  classNamePrefix: MULTI_SELECT_CLASS_NAME_PREFIX,
  styles: multiSelectScrollStyles,
}
